import React from 'react';
import { graphql } from 'gatsby';
import { TitleBlock as TitleBlockComponent } from '../../../titleBlock/TitleBlock';

export const TitleBlock = ({ data, ...rest }) => (
  <TitleBlockComponent {...data} {...rest} />
);

export const TitleBlockQuery = graphql`
  fragment TitleBlock on UMBRACO_TitleBlockComponentType {
    tag
    heading
    description
    centered
  }
`;
